import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import AdminApp from './admin/App'
import ClientApp from './client/App'

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />}/>
        <Route path="/client/*" element={<ClientApp />}/>
        <Route key="notFound" path="*" element={<Navigate replace to="/client/landingPage" />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)
